<template lang="pug">
#constituency-finder-wrapper(
  @mouseleave="toggleHover(false)"
  @mouseenter="toggleHover(true)")
  #postcode-finder-hint Would you like to see the results for your constituency?
    |  Search for a constituency, MP, or by postcode.
  input#constituency-finder(type='text'
    autocomplete="off"
    placeholder='Type a name or a postcode...'
    v-model='constituencyQuery'
    @keyup="search"
    @keyup.enter="navigateIfOnlyOneResult")
  #constituency-finder-search-results(v-if="results.length && hover")
    .constituency-finder-search-result(v-for="result in results"
      @click="navigate(result.constituencyNameEscaped)")
      div {{result.constituencyName}}
      .constituency-finder-search-result-secondary(v-if="result.winnerName")
        i.fas.fa-user
        |  {{result.winnerName}}
      .constituency-finder-search-result-secondary(v-if="result.postcode") Postcode: {{result.postcode.toUpperCase()}}
</template>

<script>
const axios = require('axios')

const BACKEND_HOST = `${location.protocol}//${location.hostname}`
const POSTCODES_REGEX = /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/

export default {
  data() {
    return {
      constituencyQuery: '',
      results: [],
      hover: false,
      hoverTimeout: null,
    }
  },
  methods: {
    search() {
      const query = this.constituencyQuery.trim()

      if (!query.length) {
        this.results = []

        return
      }

      if (query.match(POSTCODES_REGEX)) {
        axios.get(`https://api.postcodes.io/postcodes/${query}`)
          .then(results => {
            const constituencyPcon18cd = results.data.result.codes.parliamentary_constituency
            const constituencyName =
              this.$parent.staticData.constituenciesPcon18ToNames[constituencyPcon18cd]
            const constituencyNameEscaped = this.$parent.escapeString(constituencyName)

            this.results = [{
              postcode: query,
              constituencyName,
              constituencyNameEscaped
            }]
          })
          .catch(() => {
            this.results = []
          })
      } else {
        axios.get(`${BACKEND_HOST}/search?query=${query}`)
          .then(response => {
            this.results = response.data.map(result => ({
              ...result,
              constituencyNameEscaped: this.$parent.escapeString(result.constituencyName),
            }))
          })
      }
    },
    navigate(constituencyNameEscaped) {
      this.constituencyQuery = ''
      this.results = []
      this.$parent.navigate(`/constituency/${constituencyNameEscaped}`)
    },
    navigateIfOnlyOneResult() {
      if (this.results.length === 1) {
        this.navigate(this.results[0].constituencyNameEscaped)
      }
    },
    toggleHover(swtch) {
      if (swtch) {
        this.hover = true

        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout)

          this.hoverTimeout = null
        }
      } else {
        this.hoverTimeout = setTimeout(() => {
          this.hover = false
        }, 500)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
#constituency-finder-wrapper {
  position: relative;
}

#constituency-finder-search-results {
  min-width: 300px;
  right: 0;
  position: absolute;
  border: solid 1px #aeaeae;
  background: white;
  border-radius: 4px;
  margin-top: -1px;
  max-height: calc(100vh - 100px);
  overflow-y: scroll;
}

.constituency-finder-search-result {
  font-size: 1rem;
  border-bottom: solid 1px #aeaeae;
  padding: 10px 20px;
  cursor: pointer;

  &:hover {
    background-color: #f1f1f1;
  }

  &:last-child {
    border-bottom: 0;
  }
}

.constituency-finder-search-result-secondary {
  font-weight: bold;
  font-size: 0.8rem;
}
</style>
